export default __webpack_public_path__ + "static/media/ic_st_lucia.b0332035.svg";